export default function SvgAdd3() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28px"
        cursor="pointer"
        fill="none"
        viewBox="0 0 24 24"
        >
        <path
        stroke="green"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 11v3m0 0v3m0-3h3m-3 0H9M6 7h12M8 5h8M6 9h12a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6a2 2 0 012-2z"
        ></path>
    </svg>
    </>
  );
}
